<template>
  <v-card class="p-12" :loading="loading">
    <custom-popup hide-confirm max-width="900" :cons="{title:'نمایش جزئیات'}" v-model="showDetail">
      <v-card class="p-5">
        <p><span class="font-weight-bold text-info">{{ titles.title }}</span> : <span v-html="details.title"></span></p>
        <p><span class="font-weight-bold text-info">{{ titles.description }}</span> : <span
            v-html="details.description"></span></p>
        <p><span class="font-weight-bold text-info">{{ titles.is_seen }}</span> : <span
            v-html="details.is_seen === 0 ? 'دیده شده' : 'دیده نشده'"></span></p>
        <p><span class="font-weight-bold text-info">{{ titles.purpose }}</span> : <span v-html="details.purpose"></span>
        </p>
      </v-card>
    </custom-popup>

    <mixed-table
        :data="data"
        :columns="columns"
        :fetch-data="getData"
        :reload-table="reloadTable"/>
  </v-card>
</template>

<script>
import {debounce} from "@/main";
import button from "@/view/pages/button";
import MixedTable from "@/view/components/Table/MixedTable";
import PriceInput from "@/view/pages/uiBeautifier/priceInput";

export default {
  name: "reminderUser",
  components: {PriceInput, MixedTable},
  data() {
    return {
      loading: false,
      priceDialog: false,
      isEditing: false,
      showDetail: false,
      data: {},
      details: {},
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          isCheckBox: true,
          transform: (val) => {
            return `<input type="checkbox" name="checkID"  data-id="${val.data.id}">`
          },
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.data.current_page - 1;
            row = row * this.data.per_page;
            return row + val.row + 1;
          },
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
        },
        {
          label: 'شناسه QR',
          name: 'qr_id',
          orderable: true,
        },
        {
          label: 'عنوان',
          name: 'title',
          primary: true
        },
        {
          label: 'مرحله',
          name: 'step',
        },
        {
          label: 'زمان یادآوری',
          name: 'remind_date',
        },

        {
          label: 'ثبت کننده',
          name: 'user.lastName',
          primary: true
        },
        {
          label: 'مدیریت',
          name: 'action',
          component: button,
          handler: this.actions,
          event: "actions",
          meta: {
            buttons: [
              {
                name: 'seen',
                label: 'دیده شده',
                icon: 'eye',
                class: 'btn-outline-info',
                action: this.actions,
              },
              {
                name: 'show',
                label: 'مشاهده جزئیات',
                icon: 'info',
                class: 'btn-outline-primary',
                action: this.actions,
              },
            ]
          }
        }
      ],
      titles: {
        'description': 'توضیحات',
        'purpose': 'موارد پیگیری در تماس بعدی ',
        'title': 'عنوان',
        'is_seen': 'وضعیت'
      }
    }
  },
  methods: {
    getData(query = this.tableProps) {
      this.loading = true;

      this.$api.get('/admin/qr/history/user', {
        params: query
      }).then(response => {
        this.data = response.data.data;
      }).catch(reason => {
        this.$modal.error('خطا', 'در دریافت اطلاعات با خطا مواجه‌ شدیم.');

        console.log(reason.response);
      }).finally(() => {
        this.loading = false;
      });
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.tableProps.page = this.data.current_page;
        this.getData(tableProps);
      }, 1000);
    },
    seenAction(data){
      this.loading = true;

      this.$api.put(`/admin/reminder/seen/user`, {
        'type': 'qr',
        'reference' : data.id
      }).then(response => {
        this.$toast.success('وضعیت با موفقیت به روزرسانی شد.')
        this.getData();

      }).catch(reason => {
        this.$toast.error('خطای سرور!')

      }).finally(() => {
        this.loading = false;
      });
    },
    actions(data, type) {
      this[type + 'Action'](data);
    },
    showAction(data) {
      this.details = data
      this.showDetail = true;
    },
  },
  computed: {
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          this.getData();
          return true
        case 'sm':
          this.getData();
          return true
        case 'md':
          this.getData();
          return false
        case 'lg':
          this.getData();
          return false
        case 'xl':
          this.getData();
          return false
      }
    },
  },
  mounted() {
    this.getData();
  }
}

</script>

<style scoped>

</style>